
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/licenses",
      function () {
        return require("private-next-pages/licenses/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/licenses"])
      });
    }
  